document.addEventListener('DOMContentLoaded', function () {
  let products = [];

  async function fetchAllProducts(page = 1) {
    const response = await fetch(`/products.json?limit=250&page=${page}`);
    const data = await response.json();

    if (data.products.length > 0) {
      products = products.concat(data.products);
      return fetchAllProducts(page + 1);
    }
  }

  fetchAllProducts().then(() => {
    const wrappers = document.querySelectorAll('.product-search-wrapper');

    wrappers.forEach(wrapper => {
      const input = wrapper.querySelector('input');
      const suggestions = wrapper.querySelector('.product-suggestions');

      input.addEventListener('input', function () {
        const value = this.value.toLowerCase();
        suggestions.innerHTML = '';

        if (value.length < 2) return;

        const matches = [];

        products.forEach(product => {
          product.variants.forEach(variant => {
            if (variant.sku && variant.sku.toLowerCase().includes(value)) {
              matches.push({
                title: product.title,
                sku: variant.sku,
                image: product.images.length > 0 ? product.images[0].src : '',
                handle: product.handle
              });
            }
          });
        });

        matches.slice(0, 5).forEach(item => {
          const li = document.createElement('li');
          li.style.cursor = 'pointer';
          li.style.display = 'flex';
          li.style.alignItems = 'center';
          li.style.padding = '6px 10px';
          li.style.borderBottom = '1px solid #eee';

          const img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title;
          img.style.width = '40px';
          img.style.height = '40px';
          img.style.objectFit = 'cover';
          img.style.marginRight = '10px';

          const text = document.createElement('span');
          text.textContent = `${item.title} (SKU: ${item.sku})`;

          li.appendChild(img);
          li.appendChild(text);

          li.addEventListener('click', () => {
            if (wrapper.closest('.info-box-product-search')) {
              window.location.href = `/pages/warranty-support?product=${encodeURIComponent(item.handle)}`;
            } else {
              const modelInput = document.querySelector('input[name="contact[product-model-number]"]');
              if (modelInput) {
                modelInput.value = item.sku;
              }
              suggestions.innerHTML = ''; // ✅ Close the suggestion list
            }
          });

          suggestions.appendChild(li);
        });
      });
    });
  });
});
